/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAssociateUserRequest
 */
export interface ControlAssociateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlAssociateUserRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ControlAssociateUserRequest interface.
 */
export function instanceOfControlAssociateUserRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlAssociateUserRequestFromJSON(json: any): ControlAssociateUserRequest {
    return ControlAssociateUserRequestFromJSONTyped(json, false);
}

export function ControlAssociateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssociateUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ControlAssociateUserRequestToJSON(value?: ControlAssociateUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

